import parse from "html-react-parser";
import useLanguage from "../Context/useLanguage";

export const TranslatableText = (props) => {
    const {currentLanguage} = useLanguage();
    return <>{parse(props.dictionary[currentLanguage])}</>;
};
